import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import fi from './fi.json';

export const createI18nInstance = (lng: 'en' | 'fi') => {
  const instance = i18next.createInstance();

  instance.use(initReactI18next).init({
    lng,
    fallbackLng: 'fi',
    interpolation: { escapeValue: false },
    resources: {
      en: { translation: en },
      fi: { translation: fi },
    },
  });

  return instance;
};
